import { render } from "./LogoItem.vue?vue&type=template&id=92ac3606&scoped=true&ts=true"
import script from "./LogoItem.vue?vue&type=script&lang=ts"
export * from "./LogoItem.vue?vue&type=script&lang=ts"

import "./LogoItem.vue?vue&type=style&index=0&id=92ac3606&scoped=true&lang=scss"

import exportComponent from "/Users/damiandudek/Desktop/PRACA/git/114.TGA-mobile-git/tga-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92ac3606"]])

export default __exports__